import { axiosInstance } from '../axiosInstance';
import { IResData } from '../../helpers/favorites';

export const getFavoritesData = async (
  token: string | null,
  params?: Record<string, string | number>,
): Promise<IResData> => {
  const headers: { Authorization?: string } = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await axiosInstance.get(`/view/favorites/`, {
    params,
    headers,
  });
  return response.data;
};
